<template>
  <div class="chart-container" style="display:flex; align-items:flex-start;">
    <Pie 
        :data="pieData" 
        :options="pieOptions" 
        :redraw="true"
        style="flex:1; max-height:30vh;"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Pie } from 'vue-chartjs'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'

Chart.register(ArcElement, Tooltip, Legend)

const props = defineProps({
  dataInicio: String,
  dataFim:    String
})

const pieData = ref({ labels: [], datasets:[{data:[],backgroundColor:[]} ]})

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins:{
    title:{ display:true, text:'Receitas Totais Anual', align:'start' },
    tooltip:{
      callbacks:{
        label(ctx){
          return `${ctx.label}: ${ctx.parsed.toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}`
        },
        footer(ctxs){
          const total = ctxs[0].chart.data.datasets[0].data.reduce((s,v)=>s+v,0)
          return `Total: ${total.toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}`
        }
      },
      footerFont:{ weight:'bold' }
    },
    legend:{ position:'right', align:'center'}
  }
}

async function fetchPie(){
  const { data } = await axios.get(
    '/gestao/graficos/individuais/receitas-totais-anual',
    { params:{ dataInicio: props.dataInicio, dataFim: props.dataFim } }
  )
  pieData.value = {
    labels: data.labels,
    datasets:[{
      data: data.values,
      backgroundColor:[
        '#4A90E2','#1ABC9C','#F5A623','#E74C3C','#9B59B6','#34495E'
      ]
    }]
  }
}

onMounted(fetchPie)
watch(()=>[props.dataInicio,props.dataFim],fetchPie)
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 300px;
}
@media(min-width:768px){
  .chart-container { height: 400px; }
}
</style>
